import s from "./chunk920.js";
function l(r, a, i = "Mui") {
  const t = {};
  return a.forEach((e) => {
    t[e] = s(r, e, i);
  }), t;
}
export {
  l as default
};
